import { render, staticRenderFns } from "./DGAFeed.vue?vue&type=template&id=795a8121&"
import script from "./DGAFeed.vue?vue&type=script&lang=js&"
export * from "./DGAFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports